import React, { useEffect, useContext } from "react";
import Select from "react-select";
import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import TeamService from "../services/TeamService";
import UserService from "../services/UserService";
import GlobalContext from "../context/GlobalContext";
import SearchBar from "./SearchBar";
import HeaderOptions from "./HeaderOptions";

function DefaultLayout({ children, handleAuthState, handleTeamRole }) {
  const sitectx = useContext(GlobalContext);
  const navigate = useNavigate();
  const location = useLocation()
  const [teamRole, setTeamRole] = sitectx.teamRole;
  const teamServ = new TeamService();
  const userServ = new UserService();
  const [isActive, setIsActive] = useState(false);
  const [isSettingActive, setIsSettingActive] = useState(false);
  const [accountOpen, setAccountOpen] = useState(false);
  const [selectedNav, setSelectedNav] = useState(null);
  const [allOptions, setAllOptions] = useState([]);

  // const clickHandler = () => {
  //   setIsActive(!isActive);
  // };

  const changeSelection = (selection) => {
    setIsActive(selection.includes("publish_manage"));
    setIsSettingActive(selection.includes("setting"));
    setSelectedNav(selection);
    sitectx.popup.setShowPopup(false);
  };

  useEffect(() => {
    changeSelection(sitectx.navig.selection);
  }, [sitectx.navig.selection]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getTeamRole();
    getSearchAllData();
    console.log(location.pathname)
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function getSearchAllData() {
    try {
      let obj = { start: 0, length: 100 };
      let response = await userServ.listAllSearchData(obj);
      let objMap = {
        toupdate: "word",
        course: "course_name",
        toglossary: "word",
        tomint: "name",
        tonewsletter: "name",
        toprofile: "name",
        user: "user_name",
      };

      let allOptions = [];
      if (response.megaResult) {
        // for (const [key, value] of Object.entries(response.megaResult)) {
        //   response.megaResult[key] = value.map((el) => {
        //     return {
        //       value: el._id,
        //       label: el[objMap[key]],
        //       type: key,
        //     };
        //   });
        //   allOptions.push({ label: key, options: response.megaResult[key] });
        // }
        // setAllOptions(allOptions);
        // setSearchDataList(response.megaResult);
      }
    } catch (err) {
      console.log(err);
    }
  }

  const handleSearchChange = (e) => {
    // window.location.href='publish_mint';
    if (e.type === "toglossary") {
      sitectx.setSearchDetails(e);
      navigate("/publish_glossary");
    } else if (e.type === "toupdate") {
      sitectx.setSearchDetails(e);
      navigate("/publish_updates");
    } else if (e.type === "tomint") {
      sitectx.setSearchDetails(e);
      navigate("/publish_mint");
    } else if (e.type === "toprofile") {
      sitectx.setSearchDetails(e);
      navigate("/publish_profiles");
    } else if (e.type === "tonewsletter") {
      sitectx.setSearchDetails(e);
      navigate("/publish_newsletter");
    } else if (e.type === "user") {
      sitectx.setSearchDetails(e);
      navigate("/user_table");
    } else if (e.type === "course") {
      sitectx.setSearchDetails(e);
      navigate("/course");
    } else if (e.type === "publish_giftcard") {
      sitectx.setSearchDetails(e);
      navigate("/publish_giftcard");
    }
  };

  const formatGroupLabel = (data) => (
    <div>
      <span>{data.label}</span>
    </div>
  );

  const accountOpenHandler = () => {
    setAccountOpen(!accountOpen);
  };
  const getTeamRole = async () => {
    try {
      await teamServ.getDetailsByUserId(window.user.data._id).then((resp) => {
        if (resp.data) {
          setTeamRole(resp.data);
          if (resp.data.panel_access) {
            handleTeamRole(resp.data.panel_role.access_to);
          } else {
            handleTeamRole({
              dashboard: false,
              create_content: false,
              manage_content: false,
              newsletter: false,
              support_ticket: false,
              custom_url: false,
              files_drive: false,
              analytics: false,
              coins: false,
              advertising: false,
              user_database: false,
              pro_users: false,
              gift_cards: false,
              notifications: false,
              team_roles: false,
              panel_settings: false,
            });
          }
        } else {
          handleTeamRole({
            dashboard: false,
            create_content: false,
            manage_content: false,
            newsletter: false,
            support_ticket: false,
            custom_url: false,
            files_drive: false,
            analytics: false,
            coins: false,
            advertising: false,
            user_database: false,
            pro_users: false,
            gift_cards: false,
            notifications: false,
            team_roles: false,
            panel_settings: false,
          });
        }
      });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <main className="w-100 clearfix mainSection d-flex">
      <div className="w-100 clearfix leftSection navbar navbar-expand-lg p-0 sidebarWidth" id="collapsibleNavbar">
        <aside className="sidebarSection collapse navbar-collapse">
          <div className="topNav">
            <div className="logoColumn d-lg-flex d-none">
              <a href="index.html" className="d-block">
                <img src="/images/svg-icons/logo.svg" alt="logo" className="img-fluid" />
              </a>
              {/* <h5>MaveFi Admin</h5> */}
            </div>
            <div className="menuColumn menucolumn_admin b_bottom">
              <ul className="nav flex-column">
                {teamRole.panel_access && teamRole.panel_role.access_to.dashboard && (
                  <li className="nav-item marginTop3">
                    <Link
                      className={"nav-link" + (selectedNav === "dashboard" && location.pathname =="/home" ? " active" : "")}
                      to="/home"
                      onClick={() => changeSelection("dashboard")}
                    >
                      <div className="subMenuName d-flex align-items-center">
                        <img src="/images/svg-icons/Home.svg" alt="logo" className="img-fluid" />
                        <span>Dashboard</span>
                      </div>
                    </Link>
                  </li>
                )}
                {teamRole.panel_access && teamRole.panel_role.access_to.manage_content && (
                  <li className="nav-item dropdown">
                    <Link
                      className={"nav-link" + (isActive == true ? " show" : "")}
                      to="#"
                      onClick={() => {
                        changeSelection(isActive == true ? "" : "publish_manage");
                      }}
                    >
                      <div className="subMenuName d-flex align-items-center">
                        <img src="/images/svg-icons/Pen.svg" alt="logo" className="img-fluid" />
                        <span>Publish/Manage</span>
                      </div>
                      <div className="subMenuIcon">
                        <i className="fa fa-caret-down" aria-hidden="true" />
                      </div>
                    </Link>
                    <ul className={"dropdown-menu" + (isActive == true ? " show" : "")}>
                      <li>
                        <Link
                          className={"dropdown-item" + (selectedNav === "publish_manage_course" ? " active" : "")}
                          to="/course"
                          onClick={() => changeSelection("publish_manage_course")}
                        >
                          <span>Courses</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={"dropdown-item" + (selectedNav === "publish_manage_profile" ? " active" : "")}
                          to="/profile"
                          onClick={() => changeSelection("publish_manage_profile")}
                        >
                          <span>Profiles</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={"dropdown-item" + (selectedNav === "publish_manage_video" ? " active" : "")}
                          to="/video"
                          onClick={() => changeSelection("publish_manage_video")}
                        >
                          <span>Videos</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={"dropdown-item" + (selectedNav === "publish_manage_news" ? " active" : "")}
                          to="/news"
                          onClick={() => changeSelection("publish_manage_news")}
                        >
                          <span>News</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            "dropdown-item" + (selectedNav === "publish_manage_publish_glossary" ? " active" : "")
                          }
                          to="/publish_glossary"
                          onClick={() => changeSelection("publish_manage_publish_glossary")}
                        >
                          <span>Glossary</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            "dropdown-item" + (selectedNav === "publish_manage_publish_updates" ? " active" : "")
                          }
                          to="/publish_updates"
                          onClick={() => changeSelection("publish_manage_publish_updates")}
                        >
                          <span>Updates</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={"dropdown-item" + (selectedNav === "publish_manage_blogs" ? " active" : "")}
                          to="/blogs"
                          onClick={() => changeSelection("publish_manage_blogs")}
                        >
                          <span>Blog Articles</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={"dropdown-item" + (selectedNav === "publish_manage_faq" ? " active" : "")}
                          to="/faq"
                          onClick={() => changeSelection("publish_manage_faq")}
                        >
                          <span>Faqs</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={"dropdown-item" + (selectedNav === "publish_manage_careers" ? " active" : "")}
                          to="/careers"
                          onClick={() => changeSelection("publish_manage_careers")}
                        >
                          <span>Careers</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={"dropdown-item" + (selectedNav === "publish_manage_partners" ? " active" : "")}
                          to="/partners"
                          onClick={() => changeSelection("publish_manage_partners")}
                        >
                          <span>Partners</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={"dropdown-item" + (selectedNav === "publish_manage_contributers" ? " active" : "")}
                          to="/contributers"
                          onClick={() => changeSelection("publish_manage_contributers")}
                        >
                          <span>Contributors</span>
                        </Link>
                      </li>
                     
                      
                      {/* <li>
                        <Link
                          className={
                            "dropdown-item" + (selectedNav === "publish_manage_news_publisher" ? " active" : "")
                          }
                          to="/news_publisher"
                          onClick={() => changeSelection("publish_manage_news_publisher")}
                        >
                          <span>News Publisher</span>
                        </Link>
                      </li> */}
                    </ul>
                  </li>
                )}
                {teamRole.panel_access && teamRole.panel_role.access_to.newsletter && (
                  <li className="nav-item">
                    <Link
                      className={"nav-link" + (selectedNav === "newsletter" ? " active" : "")}
                      to="/newsletter"
                      onClick={() => changeSelection("newsletter")}
                    >
                      <div className="subMenuName d-flex align-items-center">
                        <img src="/images/svg-icons/Group_Message.svg" alt="logo" className="img-fluid" />
                        <span>Newsletter</span>
                      </div>
                    </Link>
                  </li>
                )}
                {teamRole.panel_access && teamRole.panel_role.access_to.support_ticket && (
                  <li className="nav-item">
                    <Link
                      className={"nav-link" + (selectedNav === "support_ticket" ? " active" : "")}
                      to="/support_ticket"
                      onClick={() => changeSelection("support_ticket")}
                    >
                      <div className="subMenuName d-flex align-items-center">
                        <img src="/images/svg-icons/Combi_Ticket.svg" alt="logo" className="img-fluid" />
                        <span>Support Tickets</span>
                      </div>
                    </Link>
                  </li>
                )}
                {teamRole.panel_access && teamRole.panel_role.access_to.custom_url && (
                  <li className="nav-item">
                    <Link
                      className={"nav-link" + (selectedNav === "custom_link" ? " active" : "")}
                      to="/custom_link"
                      onClick={() => changeSelection("custom_link")}
                    >
                      <div className="subMenuName d-flex align-items-center">
                        <img src="/images/svg-icons/Link.svg" alt="logo" className="img-fluid" />
                        <span>Custom URLs</span>
                      </div>
                    </Link>
                  </li>
                )}
                <li className="nav-item">
                  <Link
                    className={"nav-link" + (selectedNav === "search_keyword" ? " active" : "")}
                    to="/search_keyword"
                    onClick={() => changeSelection("search_keyword")}
                  >
                    <div className="subMenuName d-flex align-items-center">
                      <img src="/images/svg-icons/searchKeyCard.svg" alt="logo" className="img-fluid" />
                      <span>Search Keyword</span>
                    </div>
                  </Link>
                </li>
                {teamRole.panel_access && teamRole.panel_role.access_to.files_drive && (
                  <li className="nav-item">
                    <Link
                      className={"dropdown-item" + (selectedNav === "filesDrive" ? " active" : "")}
                      to="/filesDrive"
                      onClick={() => changeSelection("filesDrive")}
                    >
                      <div className="subMenuName d-flex align-items-center">
                        <img src="/images/svg-icons/file-drive.svg" alt="logo" className="img-fluid" />
                        <span>Files Drive</span>
                      </div>
                    </Link>
                    {/* <a className="nav-link" href="javascript:void(0);">
                    <div className="subMenuName d-flex align-items-center">
                      <img
                        src="/images/svg-icons/file-drive.svg"
                        alt="logo"
                        className="img-fluid"
                      />
                      <span>Files Drive</span>
                    </div>
                  </a> */}
                  </li>
                )}
              </ul>
            </div>
            <h5 className="adminzone_heading mb-0">ADMIN ZONE</h5>
            <div className="menuColumn menucolumn_admin mt-0">
              <ul className="nav flex-column">
                {teamRole.panel_access && teamRole.panel_role.access_to.analytics && (
                  <li className="nav-item">
                    <Link
                      className={"nav-link" + (selectedNav === "analytics" || location.pathname =="/analytics" ? " active" : "")}
                      to="/analytics"
                      onClick={() => changeSelection("analytics")}
                    >
                      <div className="subMenuName d-flex align-items-center">
                        <img src="/images/svg-icons/chart.svg" alt="logo" className="img-fluid" />
                        <span>Analytics</span>
                      </div>
                    </Link>
                  </li>
                )}
                {teamRole.panel_access && teamRole.panel_role.access_to.coins && (
                  <li className="nav-item">
                    <Link
                      className={"dropdown-item" + (selectedNav === "coins" ? " active" : "")}
                      to="/coins"
                      onClick={() => changeSelection("coins")}
                    >
                      <div className="subMenuName d-flex align-items-center">
                        <img src="/images/svg-icons/coin.svg" alt="logo" className="img-fluid" />
                        <span>Coins</span>
                      </div>
                    </Link>
                  </li>
                )}
                {teamRole.panel_access && teamRole.panel_role.access_to.advertising && (
                  <li className="nav-item">
                    <Link
                      className={"dropdown-item" + (selectedNav === "advertising" ? " active" : "")}
                      to="/advertising"
                      onClick={() => changeSelection("advertising")}
                    >
                      <div className="subMenuName d-flex align-items-center">
                        <img src="/images/svg-icons/Ads.svg" alt="logo" className="img-fluid" />
                        <span>Advertising</span>
                      </div>
                    </Link>
                  </li>
                )}
                {teamRole.panel_access && teamRole.panel_role.access_to.user_database && (
                  <li className="nav-item">
                    <Link
                      className={"dropdown-item" + (selectedNav === "userDatabase" || location.pathname== "/userDatabase"? " active" : "")}
                      to="/userDatabase"
                      onClick={() => changeSelection("userDatabse")}
                    >
                      <div className="subMenuName d-flex align-items-center">
                        <img src="/images/svg-icons/User.svg" alt="logo" className="img-fluid" />
                        <span>User Database</span>
                      </div>
                    </Link>
                  </li>
                )}
                {teamRole.panel_access && teamRole.panel_role.access_to.pro_users && (
                  <li className="nav-item">
                    <Link
                      className={"dropdown-item" + (selectedNav === "proUsers" || location.pathname =="/proUsers" ? " active" : "")}
                      to="/proUsers"
                      onClick={() => changeSelection("proUsers")}
                    >
                      <div className="subMenuName d-flex align-items-center">
                        <img src="/images/svg-icons/Lightning_Bolt.svg" alt="logo" className="img-fluid" />
                        <span>Pro Users</span>
                      </div>
                    </Link>
                  </li>
                )}
                {teamRole.panel_access && teamRole.panel_role.access_to.gift_cards && (
                  <li className="nav-item">
                    <Link
                      className={"dropdown-item" + (selectedNav === "giftcard" ? " active" : "")}
                      to="/giftcard"
                      onClick={() => changeSelection("giftcard")}
                    >
                      <div className="subMenuName d-flex align-items-center">
                        <img src="/images/svg-icons/Gift_Card.svg" alt="logo" className="img-fluid" />
                        <span>Gift Cards</span>
                      </div>
                    </Link>
                  </li>
                )}
                {teamRole.panel_access && teamRole.panel_role.access_to.notifications && (
                  <li className="nav-item">
                    <Link
                      className={"dropdown-item" + (selectedNav === "notifications" || location.pathname =="/notifications" ? " active" : "")}
                      to="/notifications"
                      onClick={() => changeSelection("notifications")}
                    >
                      <div className="subMenuName d-flex align-items-center">
                        <img src="/images/svg-icons/Notification.svg" alt="logo" className="img-fluid" />
                        <span>Notifications</span>
                      </div>
                    </Link>
                  </li>
                )}
                {teamRole.panel_access && teamRole.panel_role.access_to.team_roles && (
                  <li className="nav-item">
                    <Link
                      className={"dropdown-item" + (selectedNav === "team_roles" ||  location.pathname =="/team_roles" ? " active" : "")}
                      to="/team_roles"
                      onClick={() => changeSelection("team_roles")}
                    >
                      <div className="subMenuName d-flex align-items-center">
                        <img src="/images/svg-icons/Users.svg" alt="logo" className="img-fluid" />
                        <span>Team & Roles</span>
                      </div>
                    </Link>
                  </li>
                )}
                {teamRole.panel_access && teamRole.panel_role.access_to.panel_settings && (
                  <li className="nav-item dropdown">
                    <Link
                      className={"nav-link" + (isSettingActive == true ? " show" : "")}
                      to="#"
                      onClick={() => {
                        changeSelection(isSettingActive == true ? "" : "setting");
                      }}
                    >
                      {/* <a
                    className="nav-link"
                    href="javascript:void(0)"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  > */}
                      <div className="subMenuName d-flex align-items-center">
                        <img src="/images/svg-icons/Settings.svg" alt="logo" className="img-fluid" />
                        <span>Admin Settings</span>
                      </div>
                      <div className="subMenuIcon">
                        <i className="fa fa-caret-down" aria-hidden="true" />
                      </div>
                    </Link>
                    {/* <ul className="dropdown-menu"> */}
                    <ul className={"dropdown-menu" + (isSettingActive == true ? " show" : "")}>
                      <li>
                        <Link
                          className={"dropdown-item" + (selectedNav === "setting/general" ? " active" : "")}
                          to="/setting/general"
                          onClick={() => changeSelection("setting/general")}
                        >
                          <span>General</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={"dropdown-item" + (selectedNav === "setting/brand" ? " active" : "")}
                          to="/setting/brand"
                          onClick={() => changeSelection("setting/brand")}
                        >
                          <span>Brand</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={"dropdown-item" + (selectedNav === "setting/slider" || location.pathname =="/setting/slider" ? " active" : "")}
                          to="/setting/slider"
                          onClick={() => changeSelection("setting/slider")}
                        >
                          <span>Home Sliders</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={"dropdown-item" + (selectedNav === "setting/advertising" ? " active" : "")}
                          to="/setting/advertising"
                          onClick={() => changeSelection("setting/advertising")}
                        >
                          <span>Advertising</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={"dropdown-item" + (selectedNav === "setting/payment" ? " active" : "")}
                          to="/setting/payment"
                          onClick={() => changeSelection("setting/payment")}
                        >
                          <span>Payments</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={"dropdown-item" + (selectedNav === "setting/seo" || location.pathname =="/setting/seo"? " active" : "")}
                          to="/setting/seo"
                          onClick={() => changeSelection("setting/seo")}
                        >
                          <span>SEO</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={"dropdown-item" + (selectedNav === "setting/backup" || location.pathname =="/setting/backup"? " active" : "")}
                          to="/setting/backup"
                          onClick={() => changeSelection("setting/backup")}
                        >
                          <span>Backup</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={"dropdown-item" + (selectedNav === "setting/newsletter" ? " active" : "")}
                          to="/setting/newsletter"
                          onClick={() => changeSelection("setting/newsletter")}
                        >
                          <span>Newsletter</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={"dropdown-item" + (selectedNav === "setting/policies" ? " active" : "")}
                          to="/setting/policies"
                          onClick={() => changeSelection("setting/policies")}
                        >
                          <span>Policies</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={"dropdown-item" + (selectedNav === "setting/blocklist" ? " active" : "")}
                          to="/setting/blocklist"
                          onClick={() => changeSelection("setting/blocklist")}
                        >
                          <span>Blacklisting</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={"dropdown-item" + (selectedNav === "setting/sitemap" ? " active" : "")}
                          to="/setting/sitemap"
                          onClick={() => changeSelection("setting/sitemap")}
                        >
                          <span>Sitemap</span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </aside>
      </div>
      <div className="w-100 clearfix rightSection">
        <div className="contantSection">
          <header className="w-100 topHeaderSection bg-white">
            <div className="topHeaderInner d-flex align-items-center w-100">
              <div className="logoColumn d-flex d-lg-none">
                <a href="index.html" className="d-block">
                  <img src="/images/svg-icons/logo.svg" alt="logo" className="img-fluid" />
                </a>
              </div>
              <SearchBar />
              <HeaderOptions handleAuthState={handleAuthState} />
              <div className="toggleBtn  d-inline-block-block d-lg-none ps-3">
                <button
                  className="navbar-toggler btn"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapsibleNavbar"
                >
                  <span className="line1" />
                  <span className="line2" />
                  <span className="line3" />
                </button>
              </div>
            </div>
          </header>
        </div>
        {children}
      </div>
    </main>
  );

  // return (
  //   <main className="w-100 clearfix mainSection d-flex">
  //     <div
  //       className="w-100 clearfix leftSection navbar navbar-expand-lg p-0"
  //       id="collapsibleNavbar"
  //     >
  //       <aside className="sidebarSection collapse navbar-collapse">
  //         <div className="topNav">
  //           <div className="logoColumn d-lg-flex d-none">
  //             <Link to="index.html" className="d-flex">
  //               {/* <img
  //                 src="/assets/images/icons/Group 4545.png"
  //                 alt="logo"
  //                 className="img-fluid"
  //               />
  //               <span className="logoColumn-logotext">
  //                 <span className="admintxt">MaveFi</span>&nbsp;Admin
  //               </span> */}
  //               <img
  //                 src="/assets/images/admin_icon/logo-mavefi-admin.svg"
  //                 alt="logo"
  //                 className="img-fluid"
  //               />
  //             </Link>
  //           </div>
  //           <div className="sidebarColumn">
  //             <ul className="nav flex-column">
  //               <li className="nav-item">
  //                 <Link
  //                   className={
  //                     "nav-link d-flex" +
  //                     (selectedNav === "dashboard" ? " active" : "")
  //                   }
  //                   to="/home"
  //                   onClick={() => setSelectedNav("dashboard")}
  //                 >
  //                   <svg
  //                     className="img-fluid sidebar-img"
  //                     viewBox="0 0 15 15"
  //                     fill="none"
  //                     xmlns="http://www.w3.org/2000/svg"
  //                   >
  //                     <path
  //                       d="M8.5002 1.1333C8.35208 1.13331 8.20985 1.19131 8.10397 1.29489L1.92266 6.35062C1.91552 6.35599 1.90851 6.36152 1.90163 6.36722L1.8806 6.38493V6.38603C1.82376 6.43898 1.77842 6.50305 1.74739 6.57426C1.71635 6.64546 1.70029 6.72229 1.7002 6.79997C1.7002 6.95026 1.7599 7.09439 1.86617 7.20066C1.97244 7.30693 2.11657 7.36663 2.26686 7.36663H2.83353V13.6C2.83353 14.2261 3.3407 14.7333 3.96686 14.7333H13.0335C13.6597 14.7333 14.1669 14.2261 14.1669 13.6V7.36663H14.7335C14.8838 7.36663 15.028 7.30693 15.1342 7.20066C15.2405 7.09439 15.3002 6.95026 15.3002 6.79997C15.3003 6.7221 15.2843 6.64507 15.2532 6.57366C15.2222 6.50225 15.1768 6.438 15.1198 6.38493L15.1109 6.37829C15.0985 6.36702 15.0856 6.35631 15.0722 6.34619L14.1669 5.60576V3.39997C14.1669 3.08717 13.913 2.8333 13.6002 2.8333H13.0335C12.7207 2.8333 12.4669 3.08717 12.4669 3.39997V4.21566L8.88424 1.28493C8.77985 1.18789 8.64272 1.13375 8.5002 1.1333ZM10.2002 8.49997H12.4669V13.0333H10.2002V8.49997Z"
  //                       fill="#7D8190"
  //                     />
  //                   </svg>
  //                   <div className="sidebar-text">Dashboard</div>
  //                 </Link>
  //               </li>
  //               <li className="nav-item">
  //                 <Link
  //                   className={
  //                     "nav-link d-flex" +
  //                     (selectedNav?.indexOf("publish_manage") === 0
  //                       ? " active"
  //                       : "")
  //                   }
  //                   to="#"
  //                   onClick={() => {
  //                     clickHandler();
  //                     // setSelectedNav("publish_manage");
  //                   }}
  //                 >
  //                   {/* <img
  //                     src="/assets/images/admin_icon/Pen.svg"
  //                     alt="logo"
  //                     className="img-fluid sidebar-img"
  //                   /> */}
  //                   <svg
  //                     className="img-fluid sidebar-img"
  //                     width="15"
  //                     height="15"
  //                     viewBox="0 0 15 15"
  //                     fill="none"
  //                     xmlns="http://www.w3.org/2000/svg"
  //                   >
  //                     <path
  //                       d="M10.9031 0.700195L9.20312 2.4002L12.6031 5.8002L14.3031 4.1002L10.9031 0.700195ZM8.10964 3.53685C7.83317 3.52877 7.55317 3.6217 7.33047 3.81465L7.32936 3.81243C6.72983 4.41197 5.80312 4.66686 4.66979 4.66686C3.74046 4.66686 3.12459 5.23915 2.80046 6.32148C1.82919 9.56678 1.07218 11.8787 0.814909 12.6777L0.818229 12.6788C0.746262 12.8267 0.703125 12.9912 0.703125 13.1669C0.703125 13.2677 0.720816 13.3633 0.745182 13.4568L5.27852 8.9235C5.25415 8.83 5.23646 8.7344 5.23646 8.63353C5.23646 8.00736 5.74363 7.5002 6.36979 7.5002C6.68259 7.5002 6.96596 7.62709 7.17109 7.83223C7.37623 8.03736 7.50313 8.32073 7.50313 8.63353C7.50313 9.2597 6.99596 9.76686 6.36979 9.76686C6.26893 9.76686 6.17332 9.74917 6.07982 9.7248L1.54648 14.2581C1.63998 14.2825 1.73559 14.3002 1.83646 14.3002C2.01213 14.3002 2.17664 14.2576 2.32454 14.1862L2.32565 14.1884C3.12465 13.9311 5.43654 13.1752 8.68184 12.204C9.76417 11.8793 10.3365 11.2629 10.3365 10.3335C10.3365 9.2002 10.5914 8.27349 11.1909 7.67396L11.1887 7.67285C11.5746 7.22745 11.5611 6.55496 11.1378 6.13223L10.0044 4.99889L8.87109 3.86556C8.65944 3.65391 8.3861 3.54492 8.10964 3.53685Z"
  //                       fill="#7D8190"
  //                     />
  //                   </svg>

  //                   <div className="sidebar-text">Publish</div>
  //                   <img
  //                     src={
  //                       isActive
  //                         ? "/assets/images/icons/uparrow.png"
  //                         : "/assets/images/icons/dwnarw.png"
  //                     }
  //                     alt="logo"
  //                     className="img-fluid dwn-arrowbtn"
  //                   />
  //                 </Link>
  //                 {isActive && (
  //                   <ul className="publish_manage_ul">
  //                     <li>
  //                       <Link
  //                         className={
  //                           "dropdown-item" +
  //                           (selectedNav === "publish_manage_blogs"
  //                             ? " active"
  //                             : "")
  //                         }
  //                         to="/blogs"
  //                         onClick={() => setSelectedNav("publish_manage_blogs")}
  //                       >
  //                         Blog
  //                       </Link>
  //                     </li>
  //                     <li>
  //                       <Link
  //                         className={
  //                           "dropdown-item" +
  //                           (selectedNav === "publish_manage_publish_updates"
  //                             ? " active"
  //                             : "")
  //                         }
  //                         to="/publish_updates"
  //                         onClick={() =>
  //                           setSelectedNav("publish_manage_publish_updates")
  //                         }
  //                       >
  //                         Updates
  //                       </Link>
  //                     </li>
  //                     <li>
  //                       <Link
  //                         className={
  //                           "dropdown-item" +
  //                           (selectedNav === "publish_manage_publish_newsletter"
  //                             ? " active"
  //                             : "")
  //                         }
  //                         to="/publish_newsletter"
  //                         onClick={() =>
  //                           setSelectedNav("publish_manage_publish_newsletter")
  //                         }
  //                       >
  //                         Newsletter
  //                       </Link>
  //                     </li>
  //                     <li>
  //                       <Link
  //                         className={
  //                           "dropdown-item" +
  //                           (selectedNav === "publish_manage_publish_glossary"
  //                             ? " active"
  //                             : "")
  //                         }
  //                         to="/publish_glossary"
  //                         onClick={() =>
  //                           setSelectedNav("publish_manage_publish_glossary")
  //                         }
  //                       >
  //                         Glossary
  //                       </Link>
  //                     </li>
  //                     <li>
  //                       <Link
  //                         className={
  //                           "dropdown-item" +
  //                           (selectedNav === "publish_manage_publish_profiles"
  //                             ? " active"
  //                             : "")
  //                         }
  //                         to="/publish_profiles"
  //                         onClick={() =>
  //                           setSelectedNav("publish_manage_publish_profiles")
  //                         }
  //                       >
  //                         Profiles
  //                       </Link>
  //                     </li>
  //                     <li>
  //                       <Link
  //                         className={
  //                           "dropdown-item" +
  //                           (selectedNav === "publish_manage_course"
  //                             ? " active"
  //                             : "")
  //                         }
  //                         to="/course"
  //                         onClick={() =>
  //                           setSelectedNav("publish_manage_course")
  //                         }
  //                       >
  //                         Courses
  //                       </Link>
  //                     </li>
  //                     <li>
  //                       <Link
  //                         className={
  //                           "dropdown-item" +
  //                           (selectedNav === "publish_manage_tools"
  //                             ? " active"
  //                             : "")
  //                         }
  //                         to="/tools"
  //                         onClick={() => setSelectedNav("publish_manage_tools")}
  //                       >
  //                         Tools Suite
  //                       </Link>
  //                     </li>
  //                     <li>
  //                       <Link
  //                         className={
  //                           "dropdown-item" +
  //                           (selectedNav === "publish_manage_publish_mint"
  //                             ? " active"
  //                             : "")
  //                         }
  //                         to="/publish_mint"
  //                         onClick={() =>
  //                           setSelectedNav("publish_manage_publish_mint")
  //                         }
  //                       >
  //                         SafeMint
  //                       </Link>
  //                     </li>
  //                     <li>
  //                       <Link
  //                         className={
  //                           "dropdown-item" +
  //                           (selectedNav === "publish_manage_faq"
  //                             ? " active"
  //                             : "")
  //                         }
  //                         to="/faq"
  //                         onClick={() => setSelectedNav("publish_manage_faq")}
  //                       >
  //                         FAQ's
  //                       </Link>
  //                     </li>
  //                     <li>
  //                       <Link
  //                         className={
  //                           "dropdown-item" +
  //                           (selectedNav === "publish_manage_careers"
  //                             ? " active"
  //                             : "")
  //                         }
  //                         to="/careers"
  //                         onClick={() =>
  //                           setSelectedNav("publish_manage_careers")
  //                         }
  //                       >
  //                         Careers
  //                       </Link>
  //                     </li>
  //                     <li>
  //                       <Link
  //                         className={
  //                           "dropdown-item" +
  //                           (selectedNav === "publish_manage_partners"
  //                             ? " active"
  //                             : "")
  //                         }
  //                         to="/partners"
  //                         onClick={() =>
  //                           setSelectedNav("publish_manage_partners")
  //                         }
  //                       >
  //                         Partners
  //                       </Link>
  //                     </li>
  //                     <li>
  //                       <Link
  //                         className={
  //                           "dropdown-item" +
  //                           (selectedNav === "publish_manage_contributers"
  //                             ? " active"
  //                             : "")
  //                         }
  //                         to="/contributers"
  //                         onClick={() =>
  //                           setSelectedNav("publish_manage_contributers")
  //                         }
  //                       >
  //                         Contributors
  //                       </Link>
  //                     </li>
  //                   </ul>
  //                 )}
  //               </li>
  //               <li className="nav-item">
  //                 <Link
  //                   className={
  //                     "nav-link d-flex" +
  //                     (selectedNav === "analytics" ? " active" : "")
  //                   }
  //                   to="/analytics"
  //                   onClick={() => setSelectedNav("analytics")}
  //                 >
  //                   {/* <img
  //                     src="/assets/images/admin_icon/Analytics.svg"
  //                     alt="logo"
  //                     className="img-fluid sidebar-img"
  //                   /> */}
  //                   <svg
  //                     className="img-fluid sidebar-img"
  //                     viewBox="0 0 17 17"
  //                     fill="none"
  //                     xmlns="http://www.w3.org/2000/svg"
  //                   >
  //                     <path
  //                       d="M7.37324 2.82886C7.06044 2.82886 6.80658 3.08272 6.80658 3.39552V13.0289H9.63991V3.39552C9.63991 3.08272 9.38604 2.82886 9.07324 2.82886H7.37324ZM0.573242 3.96219V15.2955H14.7399V14.1622H1.70658V3.96219H0.573242ZM11.3399 3.96219C11.0271 3.96219 10.7732 4.21606 10.7732 4.52886V13.0289H13.6066V4.52886C13.6066 4.21606 13.3527 3.96219 13.0399 3.96219H11.3399ZM3.40658 6.22886C3.09378 6.22886 2.83991 6.48272 2.83991 6.79552V13.0289H5.67324V6.79552C5.67324 6.48272 5.41938 6.22886 5.10658 6.22886H3.40658Z"
  //                       fill="#7D8190"
  //                     />
  //                   </svg>

  //                   <div className="sidebar-text">Analytics</div>
  //                 </Link>
  //               </li>
  //               <li className="nav-item">
  //                 <Link
  //                   className={
  //                     "nav-link d-flex" +
  //                     (selectedNav === "user_table" ? " active" : "")
  //                   }
  //                   to="/user_table"
  //                   onClick={() => setSelectedNav("user_table")}
  //                 >
  //                   {/* <img
  //                     src="/assets/images/admin_icon/User.svg"
  //                     alt="logo"
  //                     className="img-fluid sidebar-img"
  //                   /> */}
  //                   <svg
  //                     className="img-fluid sidebar-img"
  //                     viewBox="0 0 17 17"
  //                     fill="none"
  //                     xmlns="http://www.w3.org/2000/svg"
  //                   >
  //                     <path
  //                       d="M8.5002 1.7002C6.62227 1.7002 5.1002 3.22226 5.1002 5.1002V5.66686C5.1002 7.5448 6.62227 9.06686 8.5002 9.06686C10.3781 9.06686 11.9002 7.5448 11.9002 5.66686V5.1002C11.9002 3.22226 10.3781 1.7002 8.5002 1.7002ZM8.49909 10.7669C6.22903 10.7669 3.31636 11.9947 2.47826 13.0844C1.96033 13.7582 2.45337 14.7335 3.30281 14.7335H13.6965C14.5459 14.7335 15.039 13.7582 14.521 13.0844C13.6829 11.9953 10.7692 10.7669 8.49909 10.7669Z"
  //                       fill="#7D8190"
  //                     />
  //                   </svg>

  //                   <div className="sidebar-text">User Database</div>
  //                 </Link>
  //               </li>
  //               <li className="nav-item">
  //                 <Link
  //                   className={
  //                     "nav-link d-flex" +
  //                     (selectedNav === "newssubscription" ? " active" : "")
  //                   }
  //                   to="/newssubscription"
  //                   onClick={() => setSelectedNav("newssubscription")}
  //                 >
  //                   {/* <img
  //                     src="/assets/images/admin_icon/Group Message.svg"
  //                     alt="logo"
  //                     className="img-fluid sidebar-img"
  //                   /> */}
  //                   <svg
  //                     className="img-fluid sidebar-img"
  //                     viewBox="0 0 17 17"
  //                     fill="none"
  //                     xmlns="http://www.w3.org/2000/svg"
  //                   >
  //                     <path
  //                       d="M3.4002 2.83355C3.32511 2.83249 3.25055 2.84636 3.18087 2.87436C3.11119 2.90237 3.04777 2.94394 2.99429 2.99666C2.94081 3.04939 2.89835 3.11222 2.86937 3.18149C2.84038 3.25077 2.82546 3.32512 2.82546 3.40022C2.82546 3.47532 2.84038 3.54967 2.86937 3.61894C2.89835 3.68822 2.94081 3.75105 2.99429 3.80378C3.04777 3.8565 3.11119 3.89807 3.18087 3.92607C3.25055 3.95408 3.32511 3.96795 3.4002 3.96689H13.6002C13.6753 3.96795 13.7498 3.95408 13.8195 3.92607C13.8892 3.89807 13.9526 3.8565 14.0061 3.80378C14.0596 3.75105 14.102 3.68822 14.131 3.61894C14.16 3.54967 14.1749 3.47532 14.1749 3.40022C14.1749 3.32512 14.16 3.25077 14.131 3.18149C14.102 3.11222 14.0596 3.04939 14.0061 2.99666C13.9526 2.94394 13.8892 2.90237 13.8195 2.87436C13.7498 2.84636 13.6753 2.83249 13.6002 2.83355H3.4002ZM2.5834 5.10022L7.81068 9.92574C8.00391 10.1042 8.252 10.1936 8.5002 10.1936C8.7484 10.1936 8.99648 10.1042 9.18971 9.92574L14.417 5.10022H2.5834ZM1.7002 5.82737V13.3656L5.62038 9.44651L1.7002 5.82737ZM15.3002 5.82737L11.38 9.44651L15.3002 13.3656V5.82737ZM6.45378 10.2157L2.5015 14.1669H14.4989L10.5477 10.2157L9.95892 10.7591C9.55659 11.1309 9.01754 11.3174 8.5013 11.3236C7.98507 11.3179 7.44491 11.1309 7.04258 10.7591L6.45378 10.2157Z"
  //                       fill="#7D8190"
  //                     />
  //                   </svg>
  //                   <div className="sidebar-text">Newsletter Subs</div>
  //                 </Link>
  //               </li>
  //               <li className="nav-item">
  //                 <Link
  //                   className={
  //                     "nav-link d-flex" +
  //                     (selectedNav === "support_ticket" ? " active" : "")
  //                   }
  //                   to="/support_ticket"
  //                   onClick={() => setSelectedNav("support_ticket")}
  //                 >
  //                   {/* <img
  //                     src="/assets/images/admin_icon/Combi Ticket.svg"
  //                     alt="logo"
  //                     className="img-fluid sidebar-img"
  //                   /> */}
  //                   <svg
  //                     className="img-fluid sidebar-img"
  //                     viewBox="0 0 17 17"
  //                     fill="none"
  //                     xmlns="http://www.w3.org/2000/svg"
  //                   >
  //                     <path
  //                       d="M3.39993 2.2666C2.77377 2.2666 2.2666 2.77377 2.2666 3.39993V9.63327C2.2666 10.2594 2.77377 10.7666 3.39993 10.7666H13.5999C14.2261 10.7666 14.7333 10.2594 14.7333 9.63327V3.39993C14.7333 2.77377 14.2261 2.2666 13.5999 2.2666H3.39993ZM5.09993 4.53327H11.8999C12.2127 4.53327 12.4666 4.78713 12.4666 5.09993C12.4666 5.41273 12.2127 5.6666 11.8999 5.6666H5.09993C4.78713 5.6666 4.53327 5.41273 4.53327 5.09993C4.53327 4.78713 4.78713 4.53327 5.09993 4.53327ZM5.09993 7.3666H11.8999C12.2127 7.3666 12.4666 7.62047 12.4666 7.93327C12.4666 8.24607 12.2127 8.49993 11.8999 8.49993H5.09993C4.78713 8.49993 4.53327 8.24607 4.53327 7.93327C4.53327 7.62047 4.78713 7.3666 5.09993 7.3666ZM4.2278 11.8999L11.7749 14.6646C12.3625 14.88 13.0138 14.5783 13.2292 13.9906L13.9951 11.8999H4.2278Z"
  //                       fill="#7D8190"
  //                     />
  //                   </svg>
  //                   <div className="sidebar-text">Support Tickets</div>
  //                 </Link>
  //               </li>
  //               <li className="nav-item">
  //                 <Link
  //                   className={
  //                     "nav-link d-flex" +
  //                     (selectedNav === "custom_link" ? " active" : "")
  //                   }
  //                   to="/custom_link"
  //                   onClick={() => setSelectedNav("custom_link")}
  //                 >
  //                   {/* <img
  //                     src="/assets/images/admin_icon/Link.svg"
  //                     alt="logo"
  //                     className="img-fluid sidebar-img"
  //                   /> */}
  //                   <svg
  //                     className="img-fluid sidebar-img"
  //                     viewBox="0 0 17 17"
  //                     fill="none"
  //                     xmlns="http://www.w3.org/2000/svg"
  //                   >
  //                     <path
  //                       d="M12.4671 1.1333C11.5588 1.1333 10.7058 1.48736 10.0632 2.12939L8.92988 3.26273C8.28785 3.90533 7.93379 4.75827 7.93379 5.66663C7.93379 6.38305 8.15672 7.06289 8.56465 7.63447L7.63496 8.56416C7.06331 8.15643 6.38311 7.9333 5.66712 7.9333C4.75876 7.9333 3.90582 8.28736 3.26322 8.92939L2.12988 10.0627C1.48785 10.7053 1.13379 11.5583 1.13379 12.4666C1.13379 13.375 1.48785 14.2279 2.12988 14.8705C2.77192 15.5131 3.62542 15.8666 4.53379 15.8666C5.44216 15.8666 6.2951 15.5126 6.9377 14.8705L8.07103 13.7372C8.71306 13.0946 9.06712 12.2417 9.06712 11.3333C9.06712 11.0211 9.02252 10.7165 8.94206 10.4235L7.92272 11.4429C7.89665 11.9863 7.68339 12.5217 7.26973 12.9359L6.13639 14.0692C5.25239 14.9532 3.81462 14.9532 2.93118 14.0692C2.04775 13.1852 2.04718 11.7475 2.93118 10.864L4.06452 9.7307C4.50652 9.2887 5.0874 9.06885 5.66823 9.06885C6.0659 9.06885 6.45969 9.17949 6.81263 9.38649L5.26647 10.9326C5.21209 10.9849 5.16867 11.0474 5.13875 11.1166C5.10884 11.1858 5.09304 11.2603 5.09227 11.3357C5.09151 11.4111 5.10579 11.4859 5.13429 11.5557C5.16278 11.6255 5.20492 11.6889 5.25823 11.7422C5.31155 11.7955 5.37496 11.8376 5.44476 11.8661C5.51456 11.8946 5.58934 11.9089 5.66473 11.9081C5.74012 11.9074 5.8146 11.8916 5.88381 11.8617C5.95302 11.8318 6.01556 11.7883 6.06777 11.734L11.7344 6.06729C11.8163 5.98769 11.8723 5.88521 11.8949 5.77328C11.9175 5.66136 11.9058 5.5452 11.8613 5.44003C11.8168 5.33487 11.7416 5.2456 11.6455 5.18393C11.5494 5.12226 11.4369 5.09107 11.3227 5.09443C11.1755 5.09882 11.0358 5.16035 10.9331 5.26598L9.38698 6.81214C8.8763 5.94338 8.9862 4.80854 9.73118 4.06403L10.8645 2.9307C11.3065 2.4887 11.8863 2.26885 12.4671 2.26885C13.048 2.26885 13.6277 2.48926 14.0697 2.9307C14.9537 3.8147 14.9537 5.25247 14.0697 6.1359L12.9364 7.26924C12.5227 7.6829 11.9868 7.89617 11.4434 7.92223L10.424 8.94157C10.717 9.02204 11.0216 9.06663 11.3338 9.06663C12.2422 9.06663 13.0951 8.71257 13.7377 8.07054L14.871 6.93721C15.5131 6.29461 15.8671 5.44167 15.8671 4.5333C15.8671 3.62493 15.5131 2.77199 14.871 2.12939C14.2284 1.48736 13.3755 1.1333 12.4671 1.1333Z"
  //                       fill="#7D8190"
  //                     />
  //                   </svg>
  //                   <div className="sidebar-text">Custom Links</div>
  //                 </Link>
  //               </li>
  //               {/* <li className="nav-item">
  //                 <Link
  //                   className={
  //                     "nav-link d-flex" +
  //                     (selectedNav === "projects" ? " active" : "")
  //                   }
  //                   to="/projects"
  //                   onClick={() => setSelectedNav("projects")}
  //                 >
  //                   {/* <img
  //                     src="/assets/images/admin_icon/View Quilt.svg"
  //                     alt="logo"
  //                     className="img-fluid sidebar-img"
  //                   /> *-/}
  //                   <svg
  //                     className="img-fluid sidebar-img"
  //                     viewBox="0 0 17 17"
  //                     fill="none"
  //                     xmlns="http://www.w3.org/2000/svg"
  //                   >
  //                     <path
  //                       d="M2.83327 2.2666C2.52047 2.2666 2.2666 2.52047 2.2666 2.83327V14.1666C2.2666 14.4794 2.52047 14.7333 2.83327 14.7333H5.09993C5.41273 14.7333 5.6666 14.4794 5.6666 14.1666V2.83327C5.6666 2.52047 5.41273 2.2666 5.09993 2.2666H2.83327ZM7.3666 2.2666C7.0538 2.2666 6.79993 2.52047 6.79993 2.83327V7.3666C6.79993 7.6794 7.0538 7.93327 7.3666 7.93327H14.1666C14.4794 7.93327 14.7333 7.6794 14.7333 7.3666V2.83327C14.7333 2.52047 14.4794 2.2666 14.1666 2.2666H7.3666ZM7.3666 9.0666C7.0538 9.0666 6.79993 9.32047 6.79993 9.63327V14.1666C6.79993 14.4794 7.0538 14.7333 7.3666 14.7333H9.63327C9.94607 14.7333 10.1999 14.4794 10.1999 14.1666V9.63327C10.1999 9.32047 9.94607 9.0666 9.63327 9.0666H7.3666ZM11.8999 9.0666C11.5871 9.0666 11.3333 9.32047 11.3333 9.63327V14.1666C11.3333 14.4794 11.5871 14.7333 11.8999 14.7333H14.1666C14.4794 14.7333 14.7333 14.4794 14.7333 14.1666V9.63327C14.7333 9.32047 14.4794 9.0666 14.1666 9.0666H11.8999Z"
  //                       fill="#7D8190"
  //                     />
  //                   </svg>
  //                   <div className="sidebar-text">Projects</div>
  //                 </Link>
  //               </li>
  //               <li className="nav-item">
  //                 <Link
  //                   className={
  //                     "nav-link d-flex" +
  //                     (selectedNav === "calendar" ? " active" : "")
  //                   }
  //                   to="/calendar"
  //                   onClick={() => setSelectedNav("calendar")}
  //                 >
  //                   {/* <img
  //                     src="/assets/images/admin_icon/Calendar.svg"
  //                     alt="logo"
  //                     className="img-fluid sidebar-img"
  //                   /> *-/}
  //                   <svg
  //                     className="img-fluid sidebar-img"
  //                     viewBox="0 0 17 17"
  //                     fill="none"
  //                     xmlns="http://www.w3.org/2000/svg"
  //                   >
  //                     <path
  //                       d="M13.5999 2.2666H3.39993C2.77377 2.2666 2.2666 2.77377 2.2666 3.39993V13.5999C2.2666 14.2261 2.77377 14.7333 3.39993 14.7333H13.5999C14.2261 14.7333 14.7333 14.2261 14.7333 13.5999V3.39993C14.7333 2.77377 14.2261 2.2666 13.5999 2.2666ZM3.9666 13.0333C3.6538 13.0333 3.39993 12.7794 3.39993 12.4666C3.39993 12.1538 3.6538 11.8999 3.9666 11.8999C4.2794 11.8999 4.53327 12.1538 4.53327 12.4666C4.53327 12.7794 4.2794 13.0333 3.9666 13.0333ZM3.9666 10.7666C3.6538 10.7666 3.39993 10.5127 3.39993 10.1999C3.39993 9.88714 3.6538 9.63327 3.9666 9.63327C4.2794 9.63327 4.53327 9.88714 4.53327 10.1999C4.53327 10.5127 4.2794 10.7666 3.9666 10.7666ZM6.23327 13.0333C5.92047 13.0333 5.6666 12.7794 5.6666 12.4666C5.6666 12.1538 5.92047 11.8999 6.23327 11.8999C6.54607 11.8999 6.79993 12.1538 6.79993 12.4666C6.79993 12.7794 6.54607 13.0333 6.23327 13.0333ZM6.23327 10.7666C5.92047 10.7666 5.6666 10.5127 5.6666 10.1999C5.6666 9.88714 5.92047 9.63327 6.23327 9.63327C6.54607 9.63327 6.79993 9.88714 6.79993 10.1999C6.79993 10.5127 6.54607 10.7666 6.23327 10.7666ZM6.23327 8.49993C5.92047 8.49993 5.6666 8.24607 5.6666 7.93327C5.6666 7.62047 5.92047 7.3666 6.23327 7.3666C6.54607 7.3666 6.79993 7.62047 6.79993 7.93327C6.79993 8.24607 6.54607 8.49993 6.23327 8.49993ZM8.49993 13.0333C8.18713 13.0333 7.93327 12.7794 7.93327 12.4666C7.93327 12.1538 8.18713 11.8999 8.49993 11.8999C8.81273 11.8999 9.0666 12.1538 9.0666 12.4666C9.0666 12.7794 8.81273 13.0333 8.49993 13.0333ZM8.49993 10.7666C8.18713 10.7666 7.93327 10.5127 7.93327 10.1999C7.93327 9.88714 8.18713 9.63327 8.49993 9.63327C8.81273 9.63327 9.0666 9.88714 9.0666 10.1999C9.0666 10.5127 8.81273 10.7666 8.49993 10.7666ZM8.49993 8.49993C8.18713 8.49993 7.93327 8.24607 7.93327 7.93327C7.93327 7.62047 8.18713 7.3666 8.49993 7.3666C8.81273 7.3666 9.0666 7.62047 9.0666 7.93327C9.0666 8.24607 8.81273 8.49993 8.49993 8.49993ZM10.7666 13.0333C10.4538 13.0333 10.1999 12.7794 10.1999 12.4666C10.1999 12.1538 10.4538 11.8999 10.7666 11.8999C11.0794 11.8999 11.3333 12.1538 11.3333 12.4666C11.3333 12.7794 11.0794 13.0333 10.7666 13.0333ZM10.7666 10.7666C10.4538 10.7666 10.1999 10.5127 10.1999 10.1999C10.1999 9.88714 10.4538 9.63327 10.7666 9.63327C11.0794 9.63327 11.3333 9.88714 11.3333 10.1999C11.3333 10.5127 11.0794 10.7666 10.7666 10.7666ZM10.1999 7.93327C10.1999 7.62047 10.4538 7.3666 10.7666 7.3666C11.0794 7.3666 11.3333 7.62047 11.3333 7.93327C11.3333 8.24607 11.0794 8.49993 10.7666 8.49993C10.4538 8.49993 10.1999 8.24607 10.1999 7.93327ZM13.0333 10.7666C12.7205 10.7666 12.4666 10.5127 12.4666 10.1999C12.4666 9.88714 12.7205 9.63327 13.0333 9.63327C13.3461 9.63327 13.5999 9.88714 13.5999 10.1999C13.5999 10.5127 13.3461 10.7666 13.0333 10.7666ZM13.0333 8.49993C12.7205 8.49993 12.4666 8.24607 12.4666 7.93327C12.4666 7.62047 12.7205 7.3666 13.0333 7.3666C13.3461 7.3666 13.5999 7.62047 13.5999 7.93327C13.5999 8.24607 13.3461 8.49993 13.0333 8.49993ZM13.5999 5.6666H3.39993V3.39993H13.5999V5.6666Z"
  //                       fill="#7D8190"
  //                     />
  //                   </svg>
  //                   <div className="sidebar-text">Calendar</div>
  //                 </Link>
  //               </li>
  //               <li className="nav-item">
  //                 <Link
  //                   className={
  //                     "nav-link d-flex" +
  //                     (selectedNav === "task" ? " active" : "")
  //                   }
  //                   to="/task"
  //                   onClick={() => setSelectedNav("task")}
  //                 >
  //                   {/* <img
  //                     src="/assets/images/admin_icon/Tasks.svg"
  //                     alt="logo"
  //                     className="img-fluid sidebar-img"
  //                   /> *-/}
  //                   <svg
  //                     className="img-fluid sidebar-img"
  //                     viewBox="0 0 17 17"
  //                     fill="none"
  //                     xmlns="http://www.w3.org/2000/svg"
  //                   >
  //                     <path
  //                       d="M3.39993 2.2666C2.78053 2.2666 2.2666 2.78053 2.2666 3.39993V4.53327C2.2666 5.15267 2.78053 5.6666 3.39993 5.6666H13.5999C14.2193 5.6666 14.7333 5.15267 14.7333 4.53327V3.39993C14.7333 2.78053 14.2193 2.2666 13.5999 2.2666H3.39993ZM5.09993 3.39993H13.5999V4.53327H5.09993V3.39993ZM3.39993 6.79993C2.78053 6.79993 2.2666 7.31387 2.2666 7.93327V9.0666C2.2666 9.686 2.78053 10.1999 3.39993 10.1999H13.5999C14.2193 10.1999 14.7333 9.686 14.7333 9.0666V7.93327C14.7333 7.31387 14.2193 6.79993 13.5999 6.79993H3.39993ZM11.3333 7.93327H13.5999V9.0666H11.3333V7.93327ZM3.39993 11.3333C2.78053 11.3333 2.2666 11.8472 2.2666 12.4666V13.5999C2.2666 14.2193 2.78053 14.7333 3.39993 14.7333H13.5999C14.2193 14.7333 14.7333 14.2193 14.7333 13.5999V12.4666C14.7333 11.8472 14.2193 11.3333 13.5999 11.3333H3.39993ZM8.49993 12.4666H13.5999V13.5999H8.49993V12.4666Z"
  //                       fill="#7D8190"
  //                     />
  //                   </svg>
  //                   <div className="sidebar-text">Tasks</div>
  //                 </Link>
  //               </li>
  //               <li className="nav-item">
  //                 <Link
  //                   className={
  //                     "nav-link d-flex" +
  //                     (selectedNav === "notepad" ? " active" : "")
  //                   }
  //                   to="/notepad"
  //                   onClick={() => setSelectedNav("notepad")}
  //                 >
  //                   {/* <img
  //                     src="/assets/images/admin_icon/Moleskine.svg"
  //                     alt="logo"
  //                     className="img-fluid sidebar-img"
  //                   /> *-/}
  //                   <svg
  //                     className="img-fluid sidebar-img"
  //                     viewBox="0 0 17 17"
  //                     fill="none"
  //                     xmlns="http://www.w3.org/2000/svg"
  //                   >
  //                     <path
  //                       d="M2.83379 1.7002V3.96686H2.26712C2.19203 3.9658 2.11748 3.97967 2.0478 4.00767C1.97811 4.03568 1.91469 4.07725 1.86122 4.12997C1.80774 4.1827 1.76528 4.24552 1.73629 4.3148C1.70731 4.38408 1.69238 4.45843 1.69238 4.53353C1.69238 4.60863 1.70731 4.68298 1.73629 4.75225C1.76528 4.82153 1.80774 4.88436 1.86122 4.93709C1.91469 4.98981 1.97811 5.03138 2.0478 5.05938C2.11748 5.08738 2.19203 5.10126 2.26712 5.1002H2.83379C3.14659 5.1002 3.40045 5.3535 3.40045 5.66686C3.40045 5.98023 3.14659 6.23353 2.83379 6.23353H2.26712C2.19203 6.23247 2.11748 6.24634 2.0478 6.27434C1.97811 6.30234 1.91469 6.34391 1.86122 6.39664C1.80774 6.44936 1.76528 6.51219 1.73629 6.58147C1.70731 6.65075 1.69238 6.7251 1.69238 6.8002C1.69238 6.87529 1.70731 6.94964 1.73629 7.01892C1.76528 7.0882 1.80774 7.15103 1.86122 7.20375C1.91469 7.25648 1.97811 7.29805 2.0478 7.32605C2.11748 7.35405 2.19203 7.36792 2.26712 7.36686H2.83379C3.14659 7.36686 3.40045 7.62016 3.40045 7.93353C3.40045 8.2469 3.14659 8.5002 2.83379 8.5002H2.26712C2.19203 8.49913 2.11748 8.51301 2.0478 8.54101C1.97811 8.56901 1.91469 8.61058 1.86122 8.6633C1.80774 8.71603 1.76528 8.77886 1.73629 8.84814C1.70731 8.91742 1.69238 8.99176 1.69238 9.06686C1.69238 9.14196 1.70731 9.21631 1.73629 9.28559C1.76528 9.35487 1.80774 9.41769 1.86122 9.47042C1.91469 9.52314 1.97811 9.56472 2.0478 9.59272C2.11748 9.62072 2.19203 9.63459 2.26712 9.63353H2.83379C3.14659 9.63353 3.40045 9.88683 3.40045 10.2002C3.40045 10.5136 3.14659 10.7669 2.83379 10.7669H2.26712C2.19203 10.7658 2.11748 10.7797 2.0478 10.8077C1.97811 10.8357 1.91469 10.8772 1.86122 10.93C1.80774 10.9827 1.76528 11.0455 1.73629 11.1148C1.70731 11.1841 1.69238 11.2584 1.69238 11.3335C1.69238 11.4086 1.70731 11.483 1.73629 11.5523C1.76528 11.6215 1.80774 11.6844 1.86122 11.7371C1.91469 11.7898 1.97811 11.8314 2.0478 11.8594C2.11748 11.8874 2.19203 11.9013 2.26712 11.9002H2.83379C3.14659 11.9002 3.40045 12.1535 3.40045 12.4669C3.40045 12.7802 3.14659 13.0335 2.83379 13.0335V15.3002H13.0338C13.66 15.3002 14.1671 14.793 14.1671 14.1669V2.83353C14.1671 2.20736 13.66 1.7002 13.0338 1.7002H2.83379ZM6.23379 4.53353H10.7671C11.0799 4.53353 11.3338 4.7874 11.3338 5.1002C11.3338 5.413 11.0799 5.66686 10.7671 5.66686H6.23379C5.92099 5.66686 5.66712 5.413 5.66712 5.1002C5.66712 4.7874 5.92099 4.53353 6.23379 4.53353ZM6.23379 6.8002H10.7671C11.0799 6.8002 11.3338 7.05406 11.3338 7.36686C11.3338 7.67966 11.0799 7.93353 10.7671 7.93353H6.23379C5.92099 7.93353 5.66712 7.67966 5.66712 7.36686C5.66712 7.05406 5.92099 6.8002 6.23379 6.8002Z"
  //                       fill="#7D8190"
  //                     />
  //                   </svg>
  //                   <div className="sidebar-text">Notepad</div>
  //                 </Link>
  //               </li>
  //               <li className="nav-item">
  //                 <Link
  //                   className={
  //                     "nav-link d-flex" +
  //                     (selectedNav === "files_drive" ? " active" : "")
  //                   }
  //                   to="/files_drive"
  //                   onClick={() => setSelectedNav("files_drive")}
  //                 >
  //                   {/* <img
  //                     src="/assets/images/admin_icon/File Explorer.svg"
  //                     alt="logo"
  //                     className="img-fluid sidebar-img"
  //                   /> *-/}
  //                   <svg
  //                     className="img-fluid sidebar-img"
  //                     viewBox="0 0 17 17"
  //                     fill="none"
  //                     xmlns="http://www.w3.org/2000/svg"
  //                   >
  //                     <path
  //                       d="M2.26712 1.7002C1.64096 1.7002 1.13379 2.20736 1.13379 2.83353V4.53353V13.0335C1.13379 13.6597 1.64096 14.1669 2.26712 14.1669H2.99316C3.1913 14.5027 3.55413 14.7335 3.96712 14.7335H5.66712C6.08012 14.7335 6.44294 14.5027 6.64108 14.1669H10.3598C10.558 14.5027 10.9208 14.7335 11.3338 14.7335H13.0338C13.4468 14.7335 13.8096 14.5027 14.0077 14.1669H14.7338C15.36 14.1669 15.8671 13.6597 15.8671 13.0335V3.96686C15.8671 3.3407 15.36 2.83353 14.7338 2.83353H6.34668L5.99694 2.25026C5.79237 1.90913 5.42356 1.7002 5.0252 1.7002H2.26712ZM4.53379 9.06686H12.4671C12.7873 9.06686 13.0338 9.31334 13.0338 9.63353V13.6002H11.3338V11.3335C11.3338 11.1832 11.2741 11.0391 11.1678 10.9329C11.0615 10.8266 10.9174 10.7669 10.7671 10.7669H6.23379C6.0835 10.7669 5.93938 10.8266 5.83311 10.9329C5.72684 11.0391 5.66714 11.1832 5.66712 11.3335V13.6002H3.96712V9.63353C3.96712 9.31334 4.21361 9.06686 4.53379 9.06686Z"
  //                       fill="#7D8190"
  //                     />
  //                   </svg>
  //                   <div className="sidebar-text">Files Drive</div>
  //                 </Link>
  //               </li> */}
  //               {/* <li className="nav-item">
  //                 <Link
  //                   className={
  //                     "nav-link d-flex" +
  //                     (selectedNav === "finance" ? " active" : "")
  //                   }
  //                   to="/finance"
  //                   onClick={() => setSelectedNav("finance")}
  //                 >
  //                   <img
  //                     src="/assets/images/admin_icon/Bank.svg"
  //                     alt="logo"
  //                     className="img-fluid sidebar-img"
  //                   />
  //                   <svg
  //                     className="img-fluid sidebar-img"
  //                     viewBox="0 0 17 17"
  //                     fill="none"
  //                     xmlns="http://www.w3.org/2000/svg"
  //                   >
  //                     <path
  //                       d="M8.5002 1.1333C8.35767 1.13375 8.22054 1.18789 8.11615 1.28493C8.11541 1.2853 8.11467 1.28566 8.11393 1.28604L2.12409 4.55212C2.03457 4.5754 1.95212 4.62023 1.88392 4.68271L1.8806 4.68493V4.68604C1.82376 4.73898 1.77842 4.80305 1.74739 4.87426C1.71635 4.94546 1.70029 5.02229 1.7002 5.09997C1.7002 5.25026 1.7599 5.39439 1.86617 5.50066C1.97244 5.60693 2.11657 5.66663 2.26686 5.66663V13.6C2.26686 14.2261 2.77403 14.7333 3.4002 14.7333H13.6002C14.2264 14.7333 14.7335 14.2261 14.7335 13.6V5.66663C14.8838 5.66663 15.028 5.60693 15.1342 5.50066C15.2405 5.39439 15.3002 5.25026 15.3002 5.09997C15.3001 5.02229 15.284 4.94546 15.253 4.87426C15.222 4.80305 15.1766 4.73898 15.1198 4.68604C15.1198 4.68567 15.1198 4.6853 15.1198 4.68493L15.1176 4.68382C15.0492 4.62078 14.9663 4.57555 14.8763 4.55212L8.88646 1.28604L8.88424 1.28493C8.77985 1.18789 8.64272 1.13375 8.5002 1.1333ZM7.93353 4.81663H9.06686V5.71865C10.0727 5.89602 10.7506 6.55477 10.7824 7.45407H9.61582C9.55802 6.98544 9.12243 6.6738 8.52233 6.6738C7.90183 6.6738 7.49193 6.96148 7.49193 7.41312C7.49193 7.77862 7.77447 7.98794 8.46921 8.13584L9.18418 8.28857C10.3759 8.53904 10.8897 9.05281 10.8897 9.97308C10.8891 11.0033 10.2064 11.6851 9.06686 11.8557V12.75H7.93353V11.859C6.83873 11.6987 6.14978 11.0535 6.11068 10.1004H7.31042C7.36822 10.5809 7.85241 10.8895 8.55111 10.8895C9.19597 10.8895 9.65234 10.5768 9.65234 10.1291C9.65234 9.75117 9.35618 9.53404 8.62858 9.37764L7.85605 9.21273C6.77542 8.98663 6.2457 8.42431 6.2457 7.52048C6.2457 6.57131 6.89936 5.9022 7.93353 5.72087V4.81663Z"
  //                       fill="#7D8190"
  //                     />
  //                   </svg>
  //                   <div className="sidebar-text">Finance Dept.</div>
  //                   <img
  //                     src="/assets/images/admin_icon/Users.svg"
  //                     alt="logo"
  //                     className="img-fluid dwn-arrowbtn"
  //                   />
  //                 </Link>
  //               </li> */}
  //               <li className="nav-item">
  //                 <Link
  //                   className={
  //                     "nav-link d-flex" +
  //                     (selectedNav === "employees" ? " active" : "")
  //                   }
  //                   to="/employees"
  //                   onClick={() => setSelectedNav("employees")}
  //                 >
  //                   {/* <img
  //                     src="/assets/images/admin_icon/Users.svg"
  //                     alt="logo"
  //                     className="img-fluid sidebar-img"
  //                   /> */}
  //                   <svg
  //                     className="img-fluid sidebar-img"
  //                     viewBox="0 0 17 17"
  //                     fill="none"
  //                     xmlns="http://www.w3.org/2000/svg"
  //                   >
  //                     <path
  //                       d="M8.5 3.3999C6.69687 3.3999 5.95 4.55647 5.95 5.9499C5.95 6.4191 6.17467 6.89066 6.17467 6.89066C6.08457 6.94279 5.93473 7.10848 5.97214 7.40088C6.04183 7.94601 6.2785 8.08349 6.42923 8.09482C6.48646 8.60369 7.03403 9.25527 7.225 9.3499V10.1103C6.8 11.3853 3.4 11.1916 3.4 14.1666H13.6C13.6 11.1916 10.2 11.3853 9.775 10.1103V9.3499C9.96653 9.25527 10.5135 8.60369 10.5708 8.09482C10.7215 8.08349 10.9582 7.94601 11.0279 7.40088C11.0653 7.10791 10.9154 6.94279 10.8253 6.89066C10.8253 6.89066 11.05 6.465 11.05 5.9499C11.05 4.918 10.6448 4.0374 9.775 4.0374C9.775 4.0374 9.47297 3.3999 8.5 3.3999ZM12.75 4.53213C12.4599 4.53213 12.213 4.58461 11.9863 4.65941C12.1104 5.04417 12.1833 5.47334 12.1833 5.9499C12.1833 6.25137 12.136 6.52775 12.076 6.75895C12.1581 7.00205 12.1864 7.26939 12.1512 7.54365C12.0713 8.16755 11.8291 8.5916 11.5248 8.8585C11.4364 9.0727 11.3154 9.27563 11.185 9.46943C11.346 9.7998 11.5815 10.0939 11.6875 10.1534V10.1601C12.8418 10.7012 14.7333 11.6109 14.7333 14.1666H17C17 11.357 14.1667 11.7604 13.8125 10.5563V10.1523C13.9717 10.0628 14.4279 9.44749 14.4755 8.96696C14.6007 8.95619 14.7984 8.82685 14.8562 8.31175C14.8874 8.03522 14.7628 7.87961 14.688 7.83031C14.688 7.83031 14.875 7.4272 14.875 6.94157C14.875 5.9669 14.5373 5.13532 13.8125 5.13532C13.8125 5.13532 13.5609 4.53213 12.75 4.53213ZM4.25 4.53324C3.4391 4.53324 3.1875 5.13532 3.1875 5.13532C2.46273 5.13532 2.125 5.96801 2.125 6.94268C2.125 7.42888 2.31204 7.83031 2.31204 7.83031C2.23668 7.87904 2.11265 8.03522 2.14382 8.31175C2.20162 8.82685 2.39931 8.9573 2.52454 8.96807C2.57214 9.4486 3.02827 10.0639 3.1875 10.1534V10.5563C2.83333 11.7599 0 11.357 0 14.1666H2.26667C2.26667 11.6109 4.1582 10.7018 5.3125 10.1601V10.1523C5.41847 10.0928 5.65404 9.80037 5.81497 9.46943C5.68464 9.27563 5.5636 9.07159 5.4752 8.85739C5.1709 8.59106 4.9281 8.16699 4.84876 7.54365C4.81306 7.26599 4.84237 6.99436 4.92624 6.74899C4.86504 6.51609 4.81667 6.23947 4.81667 5.9499C4.81667 5.48127 4.88301 5.05046 5.00371 4.65719C4.77988 4.58409 4.53617 4.53324 4.25 4.53324Z"
  //                       fill="#7D8190"
  //                     />
  //                   </svg>
  //                   <div className="sidebar-text">Employees</div>
  //                 </Link>
  //               </li>
  //               <li className="nav-item">
  //                 <Link
  //                   className={
  //                     "nav-link d-flex" +
  //                     (selectedNav === "admin_zone" ? " active" : "")
  //                   }
  //                   to="/admin_zone"
  //                   onClick={() => setSelectedNav("admin_zone")}
  //                 >
  //                   {/* <img
  //                     src="/assets/images/admin_icon/Microsoft Admin.svg"
  //                     alt="logo"
  //                     className="img-fluid sidebar-img"
  //                   /> */}
  //                   <svg
  //                     className="img-fluid sidebar-img"
  //                     viewBox="0 0 17 17"
  //                     fill="none"
  //                     xmlns="http://www.w3.org/2000/svg"
  //                   >
  //                     <path
  //                       d="M8.49993 1.7002C5.89213 1.7002 3.17969 2.289 3.17969 2.289C2.65949 2.39156 2.2666 2.84996 2.2666 3.4002V6.8002C2.2666 12.6924 7.95651 15.1552 7.95651 15.1552C8.11858 15.2442 8.30217 15.3002 8.49993 15.3002C8.6977 15.3002 8.88129 15.2442 9.04336 15.1552C9.04336 15.1552 14.7333 12.6924 14.7333 6.8002V3.4002C14.7333 2.84996 14.3404 2.39156 13.8202 2.289C13.8202 2.289 11.1077 1.7002 8.49993 1.7002ZM8.49993 2.83353C10.9576 2.83353 13.5539 3.39121 13.58 3.39688L13.5999 6.8002C13.5999 7.4088 13.527 7.97375 13.404 8.5002H8.49993V14.1602L8.49661 14.1624L8.44902 14.137L8.40697 14.1148C8.22953 14.0371 4.49384 12.345 3.59583 8.5002H8.49993V2.83353Z"
  //                       fill="#7D8190"
  //                     />
  //                   </svg>
  //                   <div className="sidebar-text">Admin Zone</div>
  //                   <img
  //                     src="/assets/images/icons/dwnarw.png"
  //                     alt="logo"
  //                     className="img-fluid dwn-arrowbtn"
  //                   />
  //                 </Link>
  //               </li>
  //               {/* <li className="nav-item dropdown">
  //                 <Link
  //                   className="nav-link d-flex"
  //                   to="#"
  //                   data-bs-toggle="dropdown"
  //                   onClick={dropDownHandler}
  //                 >
  //                   <img
  //                     src="/assets/images/icons/learn_earn.png"
  //                     alt="logo"
  //                     className="img-fluid"
  //                   />
  //                   <div className="sidebar-text">Learn & Earn</div>
  //                 </Link>
  //                 {isOpen && (
  //                   <ul className="dropdown-menu">
  //                     <li>
  //                       <Link className="dropdown-item" to="/current_courses">
  //                         Current Courses
  //                       </Link>
  //                     </li>
  //                     <li>
  //                       <Link className="dropdown-item" to="/build_courses">
  //                         Build a Course
  //                       </Link>
  //                     </li>

  //                   </ul>
  //                 )}
  //               </li> */}
  //             </ul>
  //           </div>
  //         </div>
  //       </aside>
  //     </div>
  //     <div className="w-100 clearfix rightSection">
  //       <div className="contantSection">
  //         <header className="w-100 topHeaderSection">
  //           <div className="topHeaderInner d-flex align-items-center w-100">
  //             <div className="toggleBtn  d-inline-block-block d-lg-none">
  //               <button
  //                 className="navbar-toggler btn ljBtn"
  //                 type="button"
  //                 data-bs-toggle="collapse"
  //                 data-bs-target="#collapsibleNavbar"
  //               >
  //                 <span className="line1"></span>
  //                 <span className="line2"></span>
  //                 <span className="line3"></span>
  //               </button>
  //             </div>
  //             <div className="logoColumn d-flex d-lg-none">
  //               <Link to="index.html" className="d-block">
  //                 <img
  //                   src="/assets/images/m-logo.svg"
  //                   alt="logo"
  //                   className="img-fluid"
  //                 />
  //               </Link>
  //             </div>
  //             <div className="col-xl-6 col-lg-5  headerSearchBarMain ms-lg-0 ms-auto">
  //               {/* <div className="termBtn serchBtn d-inline-block d-lg-none">
  //                 <Link to="#" className="btn ljBtn btnOne">
  //                 {/* <span>
  //                 <i className="fa fa-search" aria-hidden="true"></i>
  //               </span> */}
  //               {/* </Link> */}
  //               {/* </div> */}
  //               <button className="btn " type="button">
  //                 <img
  //                   src="/assets/images/icons/search.svg"
  //                   alt="logo"
  //                   className="img-fluid"
  //                 />
  //               </button>

  //               <Select
  //                 styles={{
  //                   control: (base) => ({
  //                     ...base,
  //                     border: 0,
  //                     boxShadow: "none",
  //                   }),
  //                 }}
  //                 className="headerSearchBarSelect"
  //                 onChange={(e) => handleSearchChange(e)}
  //                 options={allOptions}
  //                 placeholder="Search courses, profiles, glossary, users, support tickets & etc &emsp; &emsp;&emsp;&emsp;(ctrl+/)"
  //                 noOptionsMessage={() => "No data found"}
  //                 isSearchable
  //                 formatGroupLabel={formatGroupLabel}
  //                 components={{
  //                   DropdownIndicator: () => null,
  //                   IndicatorSeparator: () => null,
  //                 }}
  //               />
  //             </div>
  //             <div className="headerMenu ms-lg-auto">
  //               <div className="headerBtnSec d-flex">
  //                 <div className="termBtn d-lg-block d-none">
  //                   <Link to="#" className="d-inline-block">
  //                     <img
  //                       src="/assets/images/svg-icons/refer.png"
  //                       alt="icon"
  //                       className="img-fluid-top-bar-icon"
  //                     />
  //                   </Link>
  //                 </div>
  //                 <div className="termBtn d-lg-block d-none">
  //                   <Link to="#" className="d-inline-block">
  //                     <img
  //                       src="/assets/images/icons/box.png"
  //                       alt="icon"
  //                       className="img-fluid-top-bar-icon"
  //                     />
  //                   </Link>
  //                 </div>
  //                 <div className="termBtn d-lg-block d-none">
  //                   <Link to="#" className="d-inline-block">
  //                     <img
  //                       src="/assets/images/icons/vector4.png"
  //                       alt="icon"
  //                       className="img-fluid-top-bar-icon"
  //                     />
  //                   </Link>
  //                 </div>
  //                 <div className="termBtn d-lg-block d-none">
  //                   <Link to="#" className="d-inline-block">
  //                     <img
  //                       src="/assets/images/icons/bell.png"
  //                       alt="icon"
  //                       className="img-fluid-top-bar-icon"
  //                     />
  //                   </Link>
  //                 </div>
  //                 <div className="termBtn myaccnt">
  //                   <Link to="#" className="d-inline-block">
  //                     <img
  //                       src="/assets/images/icons/doodle.png"
  //                       className="img-fluid"
  //                       alt="circle"
  //                     />
  //                   </Link>
  //                 </div>
  //                 <div className="adminname ">
  //                   <span className="adminname name-span">Shubham Kumar</span>
  //                   <span className="adminname owner-span">
  //                     Super Admin/Owner{" "}
  //                   </span>
  //                 </div>
  //                 <div className="logoutBtn d-lg-block d-none">
  //                   <Link
  //                     to="#"
  //                     className="d-inline-block"
  //                     onClick={accountOpenHandler}
  //                   >
  //                     <img
  //                       src="/assets/images/icons/Vector6.png"
  //                       alt="mode"
  //                       className="img-fluid-dwn-arrowbtn"
  //                     />
  //                   </Link>
  //                   {accountOpen && (
  //                     <ul className="dropdown-content">
  //                       <li>
  //                         <Link to="/account">
  //                           <span>Account</span>
  //                         </Link>
  //                       </li>
  //                       <li>
  //                         <Link to="#" onClick={logoutHandler}>
  //                           <span>Logout</span>
  //                         </Link>
  //                       </li>
  //                     </ul>
  //                   )}
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </header>
  //       </div>
  //       {children}
  //     </div>
  //   </main>
  // );
}

export default DefaultLayout;
